import type { UserRole } from '@doneverse/shared'

/**
 * Roles the submitter-facing `/feedback` surface is gated to.
 *
 * The routes, the rail icon and the post-submit "View" link all read this list
 * rather than keeping their own copies — when they drifted, an escalation
 * officer ended up with a rail icon, a working route, and a confirmation toast
 * that refused to link to the thread it had just created.
 *
 * Admins are deliberately absent: their items live in the queue, and both
 * `/feedback` routes redirect them to the `/admin/feedback` equivalent.
 */
export const FEEDBACK_SURFACE_ROLES: UserRole[] = [
  'founder',
  'doer',
  'doing_team',
  'intake_team',
  'escalation_officer',
  // A DSL's Activity Log page carries the Feedback button, and the reply
  // notification links to /feedback/<id>, so the thread has to be theirs too.
  'dsl',
  'supervisor',
  'support_staff',
]
